import React from 'react';
import editIcon from '../img/edit.svg';

export const en = {
  choose_file_registry: 'Upload Registry',
  account: 'Account No.',
  invoice: 'Invoice No.',
  registry_field_number: 'Mobile Number',
  registry_field_account: 'Account No.',
  registry_field_invoice: 'Invoice No.',
  registry_field_amount: 'Amount',
  account_already_exist:
    'This account number is already in the table',
  invoice_already_exist:
    'This Invoice number is already in the table',
  registry_identifier_required:
    'Please enter mobile, account, or invoice number (at least one field)',
  ACCOUNT_DOES_NOT_BELONG_TO_CUSTOMER:
    'This account number is not linked to the specified BIN',

  registry_bin_confirmation:
    "The registry contains data that doesn't belong to the specified BIN. Are you sure you want to continue with the payment?",
  INVOICE_DOES_NOT_BELONG_TO_CUSTOMER:
    'This invoice number is not linked to the specified BIN',

  loading_recognition_header: 'Uploading the payment order',
  loading_recognition_body: 'Processing the payment order...',
  loading_recognition_init:
    'Uploading the payment order. Please, wait. Your payment order is queued for processing.',
  num_format: 'Phone number',
  field_password: 'Password',
  field_logout: 'Logout',
  field_login: 'Login',
  corp_info: 'General information',
  corp_name: 'Remitter’s company name',
  corp_address: 'Address',
  corp_bin: 'Remitter’s BIN number',
  corp_phone: 'Phone number',
  corp_bank_name: 'Bank name',
  corp_bic: 'BIC',
  corp_iban: 'IBAN',
  corp_numbers: 'Numbers',
  corp_number: 'Number',
  corp_account_number: 'Account number',
  corp_tariff: 'Tariff plan',
  corp_balance: 'Balance',
  corp_state: 'State',
  documents_report: 'Accounting documents',
  corp_file_download_error:
    'Failed to upload files due to server error',
  settings_email: 'Email address',
  street: 'str.',
  block: 'block',
  loading: 'Loading...',
  usage_details_title: 'Calls, texts and data',
  usage_details_communication_title:
    'Dear Subscriber, Your number calls details report has been successfully uploaded.Thank you for the use of the calls details report order service through my.kcell.kz.',
  usage_details_description_preamble:
    'Select any period within the past 90 days to view the details of your phone calls, text messages, etc.',
  usage_details_description_text:
    'Attention! When you order a Call Detail Report, you will be sent an SMS containing date and period of the Report.',
  usage_details_start_period: 'Beginning of period',
  usage_details_end_period: 'End of period',
  usage_details_output: 'Display',
  usage_details_email: 'To email',
  usage_details_screan: 'On screen',
  usage_details_file: 'To file',
  usage_details_file_format: 'Format',
  usage_details_include_period: 'inclusively',

  usage_details_get: 'Request itemized bill',
  file_format: 'File format',
  display: 'Display',
  on_screen: 'On screen',
  to_file: 'To file',
  to_email: 'To email',
  begining_of_period: 'Beginning of period',
  end_of_period: 'End of period',
  inclusively: 'inclusively',
  usage_details: 'Usage details',

  month: 'Month',
  year: 'Year',
  date_time: 'Date/Time',
  date: 'Date',
  type: 'Type',
  direction: 'Direction',
  desc: 'Description',
  number: 'Number',
  duration: 'Duration',
  units: 'Units',
  amount: 'Amount',

  if_num_is_saved:
    'There is no need to fill the register, if a breakdown of the payment amount per number is provided in your payment order. ',
  registry_saved:
    'There is no need to fill the register, if all numbers are on one account and any of the numbers on that account and/or invoice number is indicated in the payment details.',

  sum: 'Sum',
  get: 'Request',
  enabled: 'Enabled',
  disabled: 'Disabled',
  enable: 'Enable',
  disable: 'Disable',
  roaming: 'Roaming',
  international_calls: 'International calls',
  find_label: 'Find',

  limit: 'Limit',
  credit_limit: 'Credit limit',
  balance: 'Balance',
  contacts_data: 'Contact details',
  bonuses: 'Bonuses',
  payment_methods: 'Payment method',
  services: 'Services',
  simcard: 'SIM Card',
  min_8_characters: 'No less than 8 characters',
  required_field: 'Required field',
  active: 'Active',
  suspended: 'Suspended',
  postpaid: 'Credit',
  pia: 'Advance',
  manage_block: 'Manage blockings',
  cancel: 'Cancel',
  sim_change: 'SIM replacement',
  sim_number: 'SIM card number',
  barr_number: 'Barr',
  unbarr_number: 'Unbarr',
  replace: 'Replace',
  no_data_found: 'No data found',
  change_service: 'Change the service set',
  no_subscriber_choosen: 'No subscriber selected',
  previous: 'Prev.',
  next: 'Next',
  connect_roaming:
    'In order for Roaming service to work properly, turn on International Calls service.',
  roaming_connected: 'Roaming service is activated.',
  service_not_available:
    'Sorry, service is temporarily unavailable. Please, try again later.',
  already_exists_same_app:
    'An application with the same data already exists. Please, contact the support center.',
  int_calls_connected: 'International calls service is activated.',
  barred: 'Number is blocked.',
  unbarred: 'Number is unblocked.',
  login_title: 'Logon to corporate cabinet',
  login_title_desc:
    'Want to manage your mobile numbers? With corporate cabinet it’s effortless!',
  payment_history: 'Payment history',
  payment_history_notice:
    'Access to Payments History is temporarily available to postpaid customers only',
  fa: 'Account',
  month0: 'january',
  month1: 'february',
  month2: 'march',
  month3: 'april',
  month4: 'may',
  month5: 'june',
  month6: 'july',
  month7: 'august',
  month8: 'september',
  month9: 'october',
  month10: 'november',
  month11: 'december',
  report_documents: 'Accounting documents',
  usage_details_warning:
    'Currently some errors possible in the call details. In case of questions please contact to' +
    ' Corporate Clients Care – tel. 8 (727) 258-70-21',
  sim_change_success_message: 'SIM change successfully completed.',
  debt: 'Outstanding charges',
  availableNums: 'Available numbers',
  back: 'Back to list',
  regForm: 'Registration form',
  last_login: 'Last logged on : ',
  CUSTOMER_RESTRICTED:
    'Sorry, you have no access to report documents',
  inet_traffic: 'Data traffic',
  internet_traffic_gb: '{0} GB',
  internet_traffic_mb: '{0} MB',
  internet_every_day: 'daily',
  service_daily_otf: 'daily {0} tenge',
  service_over:
    'Standard per-MB rate (charged when you go over your allowance)',
  service_otf: '{0} tenge',
  activate: 'Activate',
  data_pack_link: 'https://www.kcell.kz/en/product/data-packs',
  disable_inet_pack_warning:
    'Are you sure you want to end this subscription? ',
  changeSuccess: 'Done!',
  subscribeTo: 'Subscribe to',
  unsubscribeFrom: 'Unsubscribe from',
  selectProductGroup: 'Select product group',
  selectPack: 'Select data pack',
  BIN_CONFIRMED: 'BIN confirmed',
  BIN_NOT_CONFIRMED: 'BIN not confirmed',
  PAYMENT_PERMITTED_FOR_KCELL_BRAND_ONLY: 'Not a Kcell number',
  AVAILABLE_FOR_PAYMENT: 'Available for payment',
  download_eregitry_instruction: 'Download instructions (PDF)',
  download_eregitry_example: 'Download registry example (CSV)',
  eregister: 'E-register',
  re_registration_number:
    'If number was re-registered, please send a register indicating account No. and a bank transfer order to email@kcell.kz',
  eregister_desc:
    'The bank transfer is the most convenient way of payment for cellular services for the legal entity. If you pay for communication services by bank transfer in one installment for several numbers, then in order to timely credit the amounts to the accounts of subscriber numbers it will be required to provide the register to the payment order, indicating the subscriber numbers and corresponding amounts to be credited. To send a register for crediting the amounts, use a special form.',
  enter_feedback_details: 'Enter data for feedback.',
  payment_details: 'Payment details',
  eregistry_warning:
    '*Note! Sums will be credited to subscriber numbers within 24 hours of receipt of documents, with the exception of weekends and holidays.If during the above time the sum is not entered into the account of subscriber numbers, please inform us accordingly by phone: +7 727 2587021 or from mobile: 9099',
  require_all_fiels: 'All fields are required',
  require_bin: 'Please, enter your BIN',
  require_company_name: 'Please, enter your company name',
  require_contact_phone: 'Please, enter your contact phone number',
  require_email: 'Please, provide your email',
  require_payment_account: 'Please, enter Kcell payment account',
  require_payment_order_number:
    'Please, enter your payment order number',
  require_payment_amount: 'Please, enter payment amount',
  require_payment_order_scan:
    'Please, attach a scanned copy of your payment order',
  require_account_and_amount:
    'Please, specify mobile accounts and amount to be credited to each of them',
  entered_bin_belongs_to_kcell: 'This BIN belongs to Kcell',
  amount_do_not_much: 'Amounts do not match',
  paymentSum_error:
    'The amount in the register does not match the amount in the payment order. Please check and upload the register again.',
  invalid_bin: 'Invalid BIN',
  require_number: 'Please, enter number',
  register_send_success: 'Register has been successfully sent out',
  file_is_large: 'The file is too large',
  save: 'Save',
  close: 'Close',
  choose_file: 'Upload the payment order',
  choose_file_numbers: 'Download the register of numbers',
  status: 'Status',
  add: 'Add',
  delete: 'Delete',
  e_registry_before_upload:
    ' Before the upload, file should be saved in one of the following formats: CSV, XLS, XLSX.',
  numbers: 'Numbers',
  e_registry_numbers_desc:
    'To simplify data entry, you can upload a pre-configured registry file. Form your spreadsheet using our official layout template:',
  send_e_registry: 'Send the register',
  attention: 'Attention',
  e_registry_upload_desc:
    'For payment confirmation download the scanned copy of the payment document. If the' +
    ' payment order is dated today, the document should be affixed with the seal of the bank or your organization.',
  e_registry_upload_warning:
    'Files to be uploaded should not be larger than 5MB in size. Allowed file format: PDF',
  payment_details_warn:
    'Important! The bank details in the application form should match those in the payment order, otherwise the payment will not be credited.',
  payment_details_info:
    'To automatically fill in the fields, please upload the payment order with the bank\'s stamp in PDF format. To do this, click on the "Upload payment order" button.',
  payment_date_info:
    'If the value date is not indicated in the payment order, enter the payment date in this field. If both dates are indicated, enter the value date.',
  payment_sum: 'Amount in the payment order',
  kcell_payment_account: "Beneficiary's IIC (Kcell Current Account)",
  payment_order_num: 'Payment order No. *',
  payment_date: 'Value date',
  read_payment_order_desc:
    'To automatically fill in the fields, upload a scanned form of the payment order. To manually fill in the fields or in case of incorrect data reading, click the "Edit" button.',
  read_payment_order_error:
    'Failed to read the payment order. Please use the "Edit" button to manually fill in the fields.',
  read_payment_order: 'Payment order reading',
  edit: 'Edit',
  yes: 'Yes',
  no: 'No',
  bin_error: 'Check if BIN number is correct',
  number_already_exist:
    'This number is already included in the table',
  invalid_file_format: 'Invalid file format',
  same_numbers_in_file: 'Same numbers in file',
  numbers_has_been_exceeded:
    'The limit of 3500 numbers has been exceeded.',
  e_registry_send_warning:
    'By clicking the “Send registry” button, you confirm the correctness of the parameters entered in the registry.',
  require_payment_date: 'Please, enter payment date',
  request_has_been_processed:
    'Request has been or is being processed.',
  table_contains_error: 'Table contains error',
  traffic_volume: 'Volume',
  MONTHLY_FEE: 'Monthly fee',
  DAILY_FEE: 'Daily fee',
  linkToDesc: 'Link to description',
  mb: 'MB.',
  confirme_deactivation_of_service:
    'Please, confirm deactivation of service',
  service_successfuly_activated:
    'Service has been successfully activated',
  service_successfuly_deactivated:
    'Service has been successfully deactivated',
  invalid_sum_in_file: 'Uploading registry contains invalid amounts',
  invoice_title: 'Prepayment bill',
  invoice_msisdn: 'Phone number',
  invoice_msisdn_format:
    'Введите 11 значный номер в формате +7(7XX)XXXXXXX',
  invoice_bin: 'Enter 12-digit BIN',
  invoice_org_name: 'Enter company name',
  invoice_address: "Enter your company's registered office address",
  invoice_payment_account: 'Enter account number',
  invoice_payment_amount: 'Enter the amount you pay',
  invoice_payment_min_amount:
    'Enter payment amount. Minimum payment – 100 tenge',
  invoice_service_type: 'Выберите тип сервиса',
  invoice_payment_for_equipment: 'Equipment',
  invoice_payment_for_service: 'Mobile communicaiton services',
  invoice_payment_for_equipment_doc:
    'Авансовый платеж за оборудование',
  invoice_payment_for_service_doc:
    'Авансовый платеж за услуги сотовой связи',
  invoice_generate_pdf: 'Download',
  sim_change_disable_alert: 'Service is unavailable.',
  please_select_date: 'Please, select date from calendar',
  report_docs_restricted:
    'Dear customer! For technical reasons, invoices for 01.07.2016 - 31.03.2017 period can be obtained upon request sent to email@kcell.kz. Sorry for the temporary inconvenience caused.',
  disabled_handbook_description: (
    <div className="service-description">
      <p>
        Mobile reference book – is the reference book of your
        employees’ contacts in your pocket. The service is available
        for corporate clients (legal entities and individual
        entrepreneurs) who are both pre-paid and post-paid subscribers
        of Kcell. Any of the employees receives instantly the
        information about colleague through a free SMS request.
      </p>
      <br />
      <p>
        Mobile reference book can help to solve quickly such working
        issues as:
        <ul>
          <li>
            Find the number of colleague who is late for a meeting
          </li>
          <li>
            Find out which colleague blocked you in the parking lot,
            using the car registration number
          </li>
          <li>
            Find the name and position of the person who called you
          </li>
        </ul>
      </p>
      <br />
      <p>
        It is easy and simple to manage the service from your personal
        cabinet by pressing a few buttons. You also have an
        opportunity to divide your employees into two categories, and
        keep VIP category invisible to other employees, while the VIP,
        in turn, will see information on any employee. The free
        identifier 4040 is also provided to you within the service.
      </p>
      <br />
      <p>
        You can get details of the service from your customer service
        representative of Kcell or call 9099 from mobile phone, and
        also (727) 258 70 21 from a landline.
      </p>
    </div>
  ),
  enabled_handbook_description: (
    <div className="service-description">
      <p>
        Welcome to the personal cabinet of Mobile reference book. You
        can manage the lists yourself by a few simple steps.
      </p>
      <br />
      <p>
        You can download, delete, and edit data of your employees in
        the table below. Also for your convenience, you can update
        completely the list or supplement it by loading Excel file.
      </p>
      <br />
      <p>
        In order to make small changes you just need to pass the mouse
        on necessary field and make them.
      </p>
      <br />
      <p>
        In order to enter the initial data or add a large number of
        fields, for your convenience, make the following steps:
        <ol>
          <li>Download Excel file</li>
          <li>
            Add necessary information in the downloaded file fields
          </li>
          <li>Upload Excel file</li>
        </ol>
        After these steps, the system will update the data.
      </p>
      <br />
      <p>
        If you have any questions, please contact your customer
        service representative of Kcell or call 9099 from mobile
        phone, and also (727) 258 70 21 from a landline.
      </p>
    </div>
  ),
  new_cabinet_info_title: 'New Cabinet for corporate clients!',
  new_cabinet_info_text: (
    <div style={{ marginLeft: '20px' }}>
      <p>
        The new Cabinet is available to all registered service users!
        Click this link and the click Forgot your password? to get
        access.
      </p>
      <p>
        To activate service, please submit a signed and stamped
        written request on your company letterhead (
        <a href="https://static.kcell.kz/b2b/page/cabinet/application-en.docx">
          request form
        </a>
        );
      </p>
      <p>
        Send a scan of the duly signed and sealed application form to{' '}
        <a
          href="mailto:email@kcell.kz"
          rel="nofollow"
          title="Follow link"
        >
          email@kcell.kz
        </a>
        .
      </p>
      <br />
      <p className="small-text">
        <a
          target="_blank"
          href="https://static.kcell.kz/files/kcell/docs/b2b_selfcare_service_instruction.pdf"
        >
          Download instructions for managing corporate cabinet (PDF)
        </a>
        <br />
      </p>
    </div>
  ),
  old_cabinet_title: 'Old version of corporate clients',
  old_cabinet_title_info: (
    <div>
      <p>
        Please, be notified that that the current version of My
        Account will be available through to 15 August 2018.
      </p>
      <p>
        To try the new version of My Account, go to{' '}
        <a target="_blank" href="https://cabinet.kcell.kz/">
          {' '}
          https://cabinet.kcell.kz
        </a>{' '}
        and click "Forgot your password?"
        <br />
      </p>
    </div>
  ),
  visual_src: '/public/images/new-cabinet-visual-en.jpg',
  training_video: 'Watch the training video',
  training_video_iframe: (
    <iframe
      width="854"
      height="480"
      src="https://www.youtube.com/embed/OxXX1aswMOk"
      frameBorder={0}
      allowFullScreen={true}
    />
  ),
  null_amount: 'Amount 0 not allowed',
  upload_doc_success_message:
    'Make sure the data was read correctly and matches the uploaded payment order. If not - edit the fields manually.',
  upload_doc_error_message1: (
    <span>
      Failed to read the document. Please upload the payment order
      again. You have only 1 attempt left. You can also fill in the
      fields manually by clicking on the
      <img
        style={{ margin: '0px 5px' }}
        src={editIcon}
        alt="edit-icon"
      />
      icon.
    </span>
  ),
  upload_doc_error_message2:
    'Failed to read the document. Please upload the payment order again. You have 2 attempts to do it, then you can edit the fields manually.',
  upload_doc_error_message3: (
    <span>
      Failed to read the document. Please fill in the fields manually
      by clicking on the
      <img
        style={{ margin: '0px 5px' }}
        src={editIcon}
        alt="edit-icon"
      />
      icon.
    </span>
  ),

  sap_hana_migration_notice: `Dear Customers,

Notice is hereby given that Kcell JSC is scheduled to transition to the new SAP HANA enterprise resource planning and management system on July 1, 2026.
To ensure that your contractual payments are processed and credited to your accounts on time, we highly recommend initiating all bank transfers no later than June 26–28, 2026.

This proactive measure aims to mitigate potential delays in payment processing during the migration to the new SAP HANA platform, as well as throughout its post-migration stabilization phase. Following the official launch of SAP HANA, additional backend optimizations may be conducted to automate specific processes, including the processing, identification, and allocation of incoming funds.

Please note that payments received during the system migration and immediately following the launch of SAP HANA may experience extended processing times.

Rest assured, all payment obligations of our retail and business customers will be deemed fully executed in compliance with contract terms and Kazakhstani legislation, regardless of our internal processing timelines.

All terms and conditions of your existing contracts remain unchanged.

Thank you for your understanding and continued cooperation.
Should you have questions, contact Support at 8 (727) 258-70-21, 9099 from mobile or write to us at email@kcell.kz`,

  new_erp_registry_notice_intro:
    'Dear Customer,\nStarting July 1, 2026, you can process payments via Electronic Registry using either a billing account or an invoice number.',

  new_erp_registry_notice_params:
    'The registry now accepts any of the following parameters: mobile number, billing account, or invoice number.',

  new_erp_registry_notice_template:
    'Please download the updated registry template:',

  new_erp_registry_template_link: 'Download Template (CSV)',

  new_erp_registry_notice_instruction:
    'Be sure to review the latest guidelines:',

  new_erp_registry_instruction_link: 'Download Guidelines (PDF)',
  check_e_registry: 'Check registry',
  eregistry_video_instruction: 'Video Guide',
};
